'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import I18n from 'I18n';
import Immutable from 'immutable';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import InitialFilterParams from '../constants/InitialFilterParams';
import { getParentCategory, isMainCategory } from '../utils/sidebarUtils';
import { areAllSidebarFiltersAtInitialValue, getClearedSidebarFilters, getMultiselectFilterObjAfterRemove } from '../utils/utils';
import { getCategoryOptionText, getIndustryOptionText, getPageLayoutOptionText, getTemplatePurposeOptionText, getMultiselectFilterOptionOrTitleText, getProviderOptionText } from '../utils/langUtils';
export default createReactClass({
  displayName: "InlineCurrentFilters",
  mixins: [ComponentWithPartials, PureRenderMixin],
  propTypes: {
    goodFilters: PropTypes.instanceOf(Immutable.Map).isRequired,
    onGoodFilterChange: PropTypes.func.isRequired
  },
  handleMultiselectFilterRemoval: function handleMultiselectFilterRemoval(filterType, selectedFilters, filterToRemove) {
    return this.props.onGoodFilterChange(getMultiselectFilterObjAfterRemove(filterType, selectedFilters, filterToRemove));
  },
  renderFilter: function renderFilter(currentFilter, filterTextLookup, removeFilter) {
    return React.createElement(UITag, {
      className: "integrate-current-filter-tag",
      closeable: true,
      inline: true,
      key: currentFilter,
      onCloseClick: removeFilter
    }, filterTextLookup(currentFilter));
  },
  renderCategoryFilter: function renderCategoryFilter(categoryFilter) {
    return this.renderSingleSelectFilter(categoryFilter, GoodFiltersAndPage.SUB_TYPE, getCategoryOptionText);
  },
  renderMultiselectFilters: function renderMultiselectFilters(filterType, filters) {
    var _this = this;

    return filters.map(function (filter) {
      return _this.renderFilter(filter, _this.partial(getMultiselectFilterOptionOrTitleText, filterType), _this.partial(_this.handleMultiselectFilterRemoval, filterType, filters, filter));
    });
  },
  renderSingleSelectFilter: function renderSingleSelectFilter(currentFilter, filterType, filterTextLookup) {
    var onGoodFilterChange = this.props.onGoodFilterChange;
    var defaultValue = filterType === GoodFiltersAndPage.SUB_TYPE ? getParentCategory(currentFilter) : InitialFilterParams.get(filterType);

    if (currentFilter !== defaultValue) {
      return this.renderFilter(currentFilter, filterTextLookup, this.partial(onGoodFilterChange, _defineProperty({}, filterType, defaultValue)));
    }

    return null;
  },
  renderPageLayoutFilter: function renderPageLayoutFilter(pageLayoutFilter) {
    return this.renderSingleSelectFilter(pageLayoutFilter, GoodFiltersAndPage.PAGE_LAYOUT, getPageLayoutOptionText);
  },
  renderTemplatePurposeFilter: function renderTemplatePurposeFilter(templatePurposeFilter) {
    return this.renderSingleSelectFilter(templatePurposeFilter, GoodFiltersAndPage.TEMPLATE_PURPOSE, getTemplatePurposeOptionText);
  },
  renderIndustryFilter: function renderIndustryFilter(industryFilter) {
    return this.renderSingleSelectFilter(industryFilter, GoodFiltersAndPage.INDUSTRY, getIndustryOptionText);
  },
  renderProviderFilter: function renderProviderFilter(providerFilter) {
    return this.renderSingleSelectFilter(providerFilter, GoodFiltersAndPage.PROVIDER, getProviderOptionText);
  },
  renderSidebarFilterTags: function renderSidebarFilterTags(goodFilters, onGoodFilterChange) {
    var categoryFilter = goodFilters.get(GoodFiltersAndPage.SUB_TYPE);
    var childTypeFilters = goodFilters.get(GoodFiltersAndPage.CHILD_TYPES);
    var codingTypeFilters = goodFilters.get(GoodFiltersAndPage.CODING_TYPE);
    var priceFilters = goodFilters.get(GoodFiltersAndPage.PRICE);
    var industryFilter = goodFilters.get(GoodFiltersAndPage.INDUSTRY);
    var featureFilters = goodFilters.get(GoodFiltersAndPage.FEATURES);
    var pageLayoutFilter = goodFilters.get(GoodFiltersAndPage.PAGE_LAYOUT);
    var templatePurposeFilter = goodFilters.get(GoodFiltersAndPage.TEMPLATE_PURPOSE);
    var customModulePurposeFilter = goodFilters.get(GoodFiltersAndPage.MODULE_PURPOSE);
    var customModuleCompatibilityFilter = goodFilters.get(GoodFiltersAndPage.MODULE_COMPATIBILITY);
    var providerFilter = goodFilters.get(GoodFiltersAndPage.PROVIDER);
    var isCategory = isMainCategory(categoryFilter);
    var mainCategory = isCategory ? categoryFilter : getParentCategory(categoryFilter);
    return React.createElement("span", null, !isCategory && I18n.text('sortingBar.filteredBy'), ' ', React.createElement(UIList, {
      inline: true
    }, !isCategory && this.renderCategoryFilter(categoryFilter), this.renderMultiselectFilters(GoodFiltersAndPage.PRICE, priceFilters), this.renderMultiselectFilters(GoodFiltersAndPage.CODING_TYPE, codingTypeFilters), this.renderMultiselectFilters(GoodFiltersAndPage.CHILD_TYPES, childTypeFilters), this.renderMultiselectFilters(GoodFiltersAndPage.FEATURES, featureFilters), this.renderPageLayoutFilter(pageLayoutFilter), this.renderTemplatePurposeFilter(templatePurposeFilter), this.renderIndustryFilter(industryFilter), this.renderMultiselectFilters(GoodFiltersAndPage.MODULE_PURPOSE, customModulePurposeFilter), this.renderMultiselectFilters(GoodFiltersAndPage.MODULE_COMPATIBILITY, customModuleCompatibilityFilter), this.renderProviderFilter(providerFilter)), React.createElement(UIButton, {
      className: "clear-filters-btn",
      size: "small",
      use: "link",
      onClick: this.partial(onGoodFilterChange, getClearedSidebarFilters(mainCategory))
    }, I18n.text('sidebar.currentFiltersCard.clearAll')));
  },
  renderMatchingSearch: function renderMatchingSearch(searchTerm) {
    return React.createElement("span", null, I18n.text('sortingBar.matching'), " ", React.createElement("strong", null, "'", searchTerm, "'"), ' ');
  },
  render: function render() {
    var _this$props = this.props,
        goodFilters = _this$props.goodFilters,
        onGoodFilterChange = _this$props.onGoodFilterChange;
    var searchTerm = goodFilters.get(GoodFiltersAndPage.SEARCH_TERM);
    return React.createElement("span", {
      className: "m-left-1"
    }, !!searchTerm && this.renderMatchingSearch(searchTerm), !areAllSidebarFiltersAtInitialValue(goodFilters) && this.renderSidebarFilterTags(goodFilters, onGoodFilterChange));
  }
});